module.exports = __webpack_public_path__ + "media/monstro-da-matematica.cd93800b.mp4";